import { EpimsBaseEntityDto } from './epim-base.dto';

export class PLActivityActionPersonDto extends EpimsBaseEntityDto{
  PLStageActivityId: string;
  StaffId: string;
  SubscriptionUserId: string;
  }
